// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".div_ucPOISuggestKey[data-v-38305ccb]{background:#fff;border:1px solid #b8b8b8}.div_ucPOISuggestKey .suggest_item_name[data-v-38305ccb]{font-size:14px;margin-left:10px}.div_ucPOISuggestKey .suggest_item_address[data-v-38305ccb]{font-size:12px;color:#b8b8b8}\n", ""]);
// Exports
module.exports = exports;
